export { InformPageWrapper } from './InformPageWrapper';
